import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./featured.module.css"; // Import the CSS module
import ImageSlider from "./ImageSlider/ImageSlider";

const defaultPromotionalSlides = [
  {
    image: "/assets/carousel-bom-sourcing.png",
    title: "Smart BOM Upload & Pricing",
    description: "Upload your BOM and move from part list to real-time sourcing insight with less manual effort.",
    buttonText: "Explore BOM Tool",
    buttonLink: "/bomManage",
  },
  {
    image: "/assets/carousel-global-sourcing.png",
    title: "Global sourcing, made simple",
    description: "Find verified component supply, compare options, and keep your procurement moving with confidence.",
    buttonText: "Browse Components",
    buttonLink: "/categories",
  },
];

const Carousel = ({ sliders }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const managedSlides = (sliders || []).map((slide, index) => ({
    ...defaultPromotionalSlides[index],
    ...slide,
    image: slide?.image || defaultPromotionalSlides[index]?.image || '',
  })).filter((slide) => slide?.image);
  const missingDefaultSlides = defaultPromotionalSlides.filter(
    (defaultSlide) => !managedSlides?.some(
      (slide) => slide?.image === defaultSlide.image || slide?.title === defaultSlide.title,
    ),
  );
  const allSlides = [...(managedSlides || []), ...missingDefaultSlides];

  const handleBeforeChange = (current, next) => {
    setCurrentSlide(next);
  };

  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    arrows: false,
    autoplay: allSlides.length > 1,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false,
    infinite: allSlides.length > 1,
    beforeChange: handleBeforeChange,
  };

  const handlePrevClick = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };

  const handleNextClick = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };




  return (
    <div className={styles.content}>
      <div className={styles.section}>
        <Slider ref={sliderRef} {...sliderSettings} className={styles.slider}>

          {
            allSlides.map((i, index) => (
              <div key={index}>
                <div className={styles.gapcontant}>
                  <ImageSlider slides={i} />
                </div>
              </div>
            ))
          }
        </Slider>

        {/* Dots for Slide Progress */}
        <div className={styles.footersec}>
          <div className={styles.dotsContainer}>
            {
              allSlides.map((i, index) => (
                <div
                  key={index}
                  className={`${styles.dot} ${index === currentSlide ? styles.active : ""
                    }`}
                >

                </div>
              ))
            }
          </div>
          {/* Navigation Arrows */}
          <div className={styles.sliderArrows}>
            <div className={styles.prevArrow} onClick={handlePrevClick}>
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="39"
                  height="39"
                  rx="19.5"
                  stroke="#B3B3B3"
                />
                <path
                  d="M23 14.5L17 20.5L23 26.5"
                  stroke="#656567"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className={styles.nextArrow} onClick={handleNextClick}>
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="40" height="40" rx="20" fill="#512DA8" />
                <path
                  d="M17 14.5L23 20.5L17 26.5"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
